module.exports = __webpack_public_path__ + "img/icon-livecasino-black.841a95ab.svg";